<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.5041 7.83333H14.0041V6.68335C14.0041 4.21668 12.3374 2.5 10.0041 2.5C7.67074 2.5 6.00407 4.21668 6.00407 6.68335V7.83333H5.50407C5.1374 7.83333 4.8374 8.13333 4.8374 8.5V16.8333C4.8374 17.2 5.1374 17.5 5.50407 17.5H14.5041C14.8707 17.5 15.1707 17.2 15.1707 16.8333V8.5C15.1707 8.13333 14.8707 7.83333 14.5041 7.83333ZM7.3374 6.68335C7.3374 4.98335 8.4374 3.83333 10.0041 3.83333C11.5707 3.83333 12.6707 4.98335 12.6707 6.68335V7.83333H7.3374V6.68335ZM13.8374 16.1667H6.17074V9.16667H13.8374V16.1667Z" fill="#29ABE2"/>
  </svg>

</template>

<script>
  export default {
    name: 'loginPass'
  }
</script>
